import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import RoleName from "../../components/role/RoleDetail/RoleName.tsx";
import {useLocationFormState} from "../../components/role/RoleForm/RoleUpdateForm";
import RoleUpdateFormProvider from "../../components/role/RoleForm/RoleUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RoleUpdateEditPage = () => {
    
    useTitle(t`Update Role`);

    const { roleId: id } = useParams();
    
    return (
        <Box data-testid="Role-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Role-update-title"
                    >
                        <Trans>Edit Role</Trans>:  <RoleName id={id}/>
                    </Typography>
                    <RoleUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default RoleUpdateEditPage;
